/**
 * Ждём, пока инструмент кадра действительно доедет.
 *
 * Серия снимает пять кадров подряд, и между ними меняется всё: слой, глубина,
 * пороги. Сетка температуры грузится с дебаунсом в четверть секунды плюс сеть,
 * линии считаются в браузере. Пауза «на глазок» иногда успевала бы, а иногда
 * клала в архив карту с включённым тумблером и пустым полем — и узнал бы об
 * этом человек уже дома.
 */

/**
 * Отвечают ли данные, лежащие в хуке, на ТЕКУЩИЙ запрос.
 *
 * Сравниваем ключи, а не флаги загрузки: между запросом и ответом хук держит
 * прежнюю сетку, и «данные есть» на её счёт — правда о прошлом кадре.
 */
export function toolPending(
  loadedKey: string | null,
  wantKey: string,
  enabled: boolean,
): boolean {
  if (!enabled) return false
  return loadedKey !== wantKey
}

const wait = (ms: number) => new Promise<void>(r => setTimeout(r, ms))

/**
 * Дождаться условия. `false` — сдались по потолку; это не отказ серии, а факт
 * для файла параметров: кадр снимается как есть, и человек об этом читает.
 *
 * Потолок обязателен по тому же уроку, что и у `waitMapIdle`: одна
 * недогруженная плитка иначе подвесила бы всю серию.
 */
export async function waitFor(
  ready: () => boolean,
  opts: { timeoutMs: number; pollMs: number; sleep?: (ms: number) => Promise<void> },
): Promise<boolean> {
  const sleep = opts.sleep ?? wait
  const steps = Math.max(0, Math.floor(opts.timeoutMs / opts.pollMs))
  for (let i = 0; i <= steps; i++) {
    if (ready()) return true
    if (i < steps) await sleep(opts.pollMs)
  }
  return ready()
}
